<template>
  <div class="content-text">
    <h2 class="title-3 text-left">9.3 eMulti</h2>

    <p>
      Quando o município tem eMulti credenciada ao recebimento de custeio, no
      FNS a ação detalhada é “INCENTIVO FINANCEIRO DA APS - EQUIPES
      MULTIPROFISSIONAIS – EMULTI”. Este recurso pode ser interpretado como está
      no quadro 12.
    </p>

    <div class="container-table">
      <span style="text-transform: uppercase; font-weight: bold"
        >Quadro 12 - DETALHAMENTO DO RECURSO MENSAL DE INCENTIVO FINANCEIRO DA
        APS - EQUIPES MULTIPROFISSIONAIS – EMULTI DO FNS
      </span>
      <table>
        <thead>
          <tr>
            <th>DESCRIÇÃO</th>
            <th>VALOR POR COMPONENTE</th>
          </tr>
        </thead>
        <tbody>
          <!-- <tr>
            <td>Fixo de implantação</td>
            <td>-</td>
            <td class="text-right">
              R$
              {{
                valorFixoImplantacao.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              }}
            </td>
          </tr> -->
          <tr>
            <td>Custeio por atendimento remoto na eMulti</td>
            <td class="text-center">
              R$
              {{
                getValorCusteio('custeio_atendimento_remoto_emulti')
                  .valorFormatado
              }}
            </td>
          </tr>
          <tr>
            <td>Custeio eMulti</td>
            <td class="text-center">
              R$ {{ getValorCusteio('custeio_emulti').valorFormatado }}
            </td>
          </tr>
          <tr>
            <td>Qualidade indicadores eMulti</td>
            <td class="text-center">
              R$
              {{
                valorQualidade.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              }}
            </td>
          </tr>
          <tr class="grey">
            <td><strong>Total</strong></td>
            <td class="text-center">
              <strong
                >R$
                {{
                  totalGeral.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                  })
                }}</strong
              >
            </td>
          </tr>
        </tbody>
      </table>
      <span class="fonte" v-html="fonte"></span>
    </div>
  </div>
</template>

<script>
import { regras, getLabelRegra } from '../utils.js'

export default {
  props: {
    dados: {
      type: Object,
      default: () => {},
    },
    fixo: {
      type: Object,
      default: () => {},
    },
    fonte: {
      type: String,
      default: '',
    },
    classificacao: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      somaGeralCusteio: 0,
    }
  },
  mounted() {},
  computed: {
    valorQualidade() {
      const equipes = this.dados?.etapa4?.equipes || []

      return equipes
        .filter((item) => {
          return (
            item.componente === 'eMulti' &&
            ['Ampliada', 'Complementar', 'Estratégica'].includes(item.equipe)
          )
        })
        .reduce((total, item) => {
          return total + Number(item.valorTotal || 0)
        }, 0)
    },

    totalGeral() {
      return (
        this.getValorCusteio('custeio_atendimento_remoto_emulti').valor +
        this.getValorCusteio('custeio_emulti').valor +
        this.valorQualidade
      )
    },
  },
  methods: {
    getValorCusteio(key) {
      const item = this.dados.etapa9.equipes.find((el) => {
        return el.key == key
      })
      if (item != undefined) {
        return {
          valor: Number(item.value),
          valorFormatado: item.value.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
          }),
        }
      } else {
        return 0
      }
    },
  },
}
</script>

<style lang="scss"></style>
